import { render, staticRenderFns } from "./multiVesselOffers.vue?vue&type=template&id=062712c6&scoped=true&"
import script from "./multiVesselOffers.vue?vue&type=script&lang=js&"
export * from "./multiVesselOffers.vue?vue&type=script&lang=js&"
import style0 from "./multiVesselOffers.vue?vue&type=style&index=0&id=062712c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062712c6",
  null
  
)

export default component.exports